import { NgTemplateOutlet } from '@angular/common'
import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { AuthorDto } from '../../../../../api/responses'
import { FormatAuthorNamePipe } from '../../../../../shared/pipes/format-author-name.pipe'

@Component({
  selector: 'dhp-author-item',
  templateUrl: './author-item.component.html',
  styleUrls: ['./author-item.component.scss'],
  imports: [NgTemplateOutlet, TranslatePipe, FormatAuthorNamePipe],
})
export class AuthorItemComponent {
  readonly author = input.required<AuthorDto>()
}
